module.exports = __webpack_public_path__ + "img/wtb@3x.03db0e7d.png";